import axios from 'axios';
import {
  DOWNLOAD_SIGNED_DOCUMENT_URL,
  get_request_config
} from '@/utils/system_constants/constant';

export function get_agreement_submission_id(agreement = {}) {
  const submission_id = Number(agreement?.submission_id || 0);
  const resolved_submission_id = submission_id > 0 ? submission_id : 0;
  return resolved_submission_id;
}

export function get_agreement_download_key(agreement = {}, submission_id = 0) {
  const download_key = String(agreement.id || submission_id);
  return download_key;
}

export function resolve_signed_document_url(payload = {}) {
  const presigned_url = String(payload?.data?.presigned_url || '').trim();
  return presigned_url;
}

export function resolve_agreement_download_error(
  error = {},
  fallbackMessage = 'Unable to download the signed document.'
) {
  const error_message = error?.response?.data?.message || error?.message || fallbackMessage;
  return error_message;
}

export function open_signed_document_url(presigned_url = '') {
  if (typeof window !== 'undefined' && presigned_url) {
    window.open(presigned_url, '_blank', 'noopener,noreferrer');
  }
}

export function set_missing_agreement_submission_error(vm) {
  vm.queue_error = 'No backend submission ID is available for this signed document.';
}

export function prepare_agreement_download_state(vm, agreement = {}, submission_id = 0) {
  vm.agreement_download_key = get_agreement_download_key(agreement, submission_id);
  vm.queue_error = '';
}

export function apply_agreement_download_payload(vm, payload = {}) {
  const presigned_url = resolve_signed_document_url(payload);
  if (!presigned_url) {
    vm.queue_error = payload?.message || 'The backend did not return a signed document URL.';
    return;
  }

  open_signed_document_url(presigned_url);
}

export async function request_signed_document_download(submission_id) {
  const response = await axios.get(
    DOWNLOAD_SIGNED_DOCUMENT_URL,
    get_request_config({
      params: { submission_id }
    })
  );
  const payload = response?.data || {};
  return payload;
}

export async function fetch_and_open_agreement_document(vm, submission_id = 0) {
  const payload = await request_signed_document_download(submission_id);
  apply_agreement_download_payload(vm, payload);
}
